import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

/**
 * PD-17425 — a company's own name for a report (for example "Week in Review"
 * for User Activity). Shown to everyone on the tenant wherever the report is
 * listed, searched, opened or sent; the report search also still finds it by
 * its original name.
 *
 * `reportKey` is the same key favorites use: a fixed report by its path
 * (`/reporting/reports/user-activity`), a custom report as
 * `custom:<reportKey>`. One row per report; clearing the name soft-deletes
 * the row and naming it again recovers it.
 */
@Index('idx_report_label_report', ['reportKey'], { unique: true })
@Entity('report_label')
export class ReportLabelEntity extends BaseEntity {
	@Column('varchar', { name: 'reportKey', length: 255 })
	public reportKey!: string;

	@Column('varchar', { name: 'label', length: 120 })
	public label!: string;
}
